const DEFAULT_SPACE_DESCRIPTION = 'default space for venue';

const asTrimmedString = (value) => {
  if (value == null) return '';
  return String(value).trim();
};

/**
 * Normalizes GET /venues/{id}/spaces payloads for customer-facing UI.
 * Filters inactive spaces and preserves API order.
 */
export function normalizeVenueSpacesForDisplay(spaces) {
  if (!Array.isArray(spaces)) return [];

  return spaces
    .filter((space) => space && space.is_active !== false)
    .map((space) => ({
      id: space.id || space.space_id || space.spaceId || null,
      name: asTrimmedString(space.name || space.space_name || space.title) || 'Space',
      description: asTrimmedString(space.description),
      capacityTotal:
        space.capacity_total ??
        space.capacityTotal ??
        space.capacity ??
        space.tables_available ??
        space.tablesAvailable ??
        null,
      hourlyPrice: space.hourly_price ?? space.hourlyPrice ?? null,
      perPersonPrice: space.per_person_price ?? space.perPersonPrice ?? null,
      defaultBookingMode: space.default_booking_mode ?? space.defaultBookingMode ?? null,
      raw: space
    }))
    .filter((space) => space.id || space.name);
}

/** Subtitle under the space name on venue details (Figma space cards). */
export function formatVenueSpaceCardSubtitle(space) {
  if (!space) return '';

  const description = asTrimmedString(space.description);
  if (description && description.toLowerCase() !== DEFAULT_SPACE_DESCRIPTION) {
    return description;
  }

  const capacity = space.capacityTotal ?? space.capacity_total ?? space.capacity;
  if (capacity != null && Number.isFinite(Number(capacity)) && Number(capacity) > 0) {
    return `Up to ${Number(capacity)} guests`;
  }

  return '';
}

export function parseVenueSpacesApiPayload(data) {
  if (Array.isArray(data)) return data;
  if (!data || typeof data !== 'object') return [];
  for (const key of ['spaces', 'data', 'items', 'results']) {
    if (Array.isArray(data[key])) return data[key];
  }
  return [];
}
